import request from '@/utils/request'
import storage from 'store'
import { TENANT } from '@/store/mutation-types'

const ssoApi = {
  isLogin: '/sso/isLogin',
  getSsoAuthUrl: '/sso/getSsoAuthUrl',
  getLoginUserInfo: '/sso/getLoginUserInfo',
  loginByTicket: '/sso/loginByTicket',
  // logout: '/sso/logout',
  logout: '/sso/signout'
}

function getAdminApiUrl (path) {
  const tenant = storage.get(TENANT)
  return process.env.VUE_APP_API_ADMIN_URL.replace("#tenant#", tenant) + path
}

export function isLogin () {
  return request({
    url: ssoApi.isLogin,
    method: 'get'
  })
}

export function getSsoAuthUrl (parameter) {
  return request({
    url: ssoApi.getSsoAuthUrl,
    method: 'get',
    params: parameter
  })
}

export function getLoginUserInfo () {
  return request({
    url: ssoApi.getLoginUserInfo,
    method: 'get'
  })
}

export function loginByTicket (parameter) {
  return request({
    url: ssoApi.loginByTicket,
    method: 'post',
    data: parameter
  })
}

export function logout () {
  return request({
    url: getAdminApiUrl(ssoApi.logout),
    method: 'post'
  })
}
